export const columns = [
  {
    name: 'Type',
    width: '100px',
    selector: row => row.type,
    cell: row => (
      <div className='d-flex justify-content-left align-items-center' onClick={() => row.onCellClick(row._id)}>
        <div className='d-flex flex-column'>
          <p className='text-truncate text-body'>
            <span className='fw-bolder'>{row.type || 'None'}</span>
          </p>
        </div>
      </div>
    )
  },
  {
    name: 'Address',
    width: '150px',
    selector: row => row.address,
    cell: row => (
      <div className='d-flex justify-content-left align-items-center' onClick={() => row.onCellClick(row._id)}>
          <p className='text-truncate text-body'>
          <span className='fw-bolder'>{`${row.address.slice(0, 5)}...${row.address.slice(-6)}`}</span><br/>
          </p>
      </div>
    )
  },
  {
    name: 'Name',
    width: '170px',
    selector: row => row?.customName ?? row.name,
    cell: row => (
      <div className='d-flex justify-content-left align-items-center' onClick={() => row.onCellClick(row._id)}>
        <p className='text-truncate text-body'>
          <span className='fw-bolder'>{row?.customName ?? row.name}</span><br />
        </p>
      </div>
    )
  },
  {
    name: 'Symbol',
    width: '120px',
    selector: row => row.symbol,
    cell: row => (
      <div className='d-flex justify-content-left align-items-center' onClick={() => row.onCellClick(row._id)}>
        <p className='text-truncate text-body'>
          <span className='fw-bolder'>{row.symbol}</span><br />
        </p>
      </div>
    )
  },
  {
    name: 'Description',
    width: '200px',
    selector: row => row?.customDescription ?? row.description,
    cell: row => (
      <div className='d-flex justify-content-left align-items-center' onClick={() => row.onCellClick(row._id)}>
        <p className='text-truncate text-body word-wrap'>
          <span className='fw-bolder' style={{ whiteSpace: 'break-spaces' }}>{row?.customDescription ?? row.description}</span><br />
        </p>
      </div>
    )
  },
  {
    name: '# of tokens',
    minWidth: '150px',
    selector: row => row.amount,
    cell: row => (
      <div className='d-flex justify-content-left align-items-center' onClick={() => row.onCellClick(row._id)}>
        <p className='text-truncate text-body'>
          <span className='fw-bolder'>{row.amount}</span><br />
        </p>
      </div>
    )
  },
]
